export default __webpack_public_path__ + "static/media/dark-theme-google-cloud-logo.1e286d59.svg";